import { ISelectOption } from "../../../components/forms/SelectControl";

export const ENCRYPT_LOGIC_SELECT: ISelectOption[] = [
  {
    label: "And",
    value: "AND",
  },
  {
    label: "Or",
    value: "OR",
  },
];
export const ENCRYPT_FIELDS: ISelectOption[] = [
  {
    label: "First Name",
    value: "first_name",
  },
  {
    label: "Last Name",
    value: "last_name",
  },
  {
    label: "Gene Id",
    value: "gene_id",
  },
];

export const ENCRYPT_OPERATORS: ISelectOption[] = [
  {
    label: "Like",
    value: "LIKE",
  },
  {
    label: "=",
    value: "=",
  },
  {
    label: "!=",
    value: "!=",
  },
  {
    label: ">",
    value: ">",
  },
  {
    label: ">=",
    value: ">=",
  },
  {
    label: "<",
    value: "<",
  },
  {
    label: "<=",
    value: "<=",
  },
];

export interface IEncryptQuerySelectAs {
  columnName?: string;
  asValue?: string;
  isDistinct?: boolean;
}

export interface IEncryptQueryConditions {
  logic?: string;
  field: string;
  operator: string;
  search: string;
}

export interface IEncryptQuery {
  selects: IEncryptQuerySelectAs[];
  conditions: IEncryptQueryConditions[];
  orderBy: string[];
  joinOn: string[];
  isSortDesc: boolean;
  limit?: string;
}

export const initialEncryptQueryValues: IEncryptQuery = {
  selects: [],
  conditions: [],
  orderBy: [],
  joinOn: [],
  isSortDesc: false,
  limit: "5",
};
